'use client'

import { useI18N } from '@susu/i18n/client'
import styles from './NavSearchResults.module.scss'

export type ClientFailedProps = {
  searchQuery: string
}

export const ClientFailed = ({ searchQuery }: ClientFailedProps) => {
  const { t } = useI18N()

  const searchNoResultsClass = styles['nav__search-noresults']

  return (
    <div className={searchNoResultsClass}>
      <span className={styles['nav__search-noresults-message']}>
        {t('navigation.no_results')}{' '}
        <span className={'body-medium'}>{`'${searchQuery}'`}</span>
      </span>
    </div>
  )
}
